import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const Loader = (props) => {
    const { size = 'big' } = props;
    return (
        <div className={`custom-loader ${size}`}>
            <svg className="circular" viewBox="25 25 50 50">
                <circle
                    className="path"
                    cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                />
            </svg>
        </div>
    );
};

Loader.propTypes = {
    size: PropTypes.string,
};

export default Loader;
